import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
// primeReact
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
// context
import { useContextSimulator } from "../../SimulatorContext";
// services
import { getUsers } from "../../../../../../services/GeneralRegistration/getUsers";
import { patchClientContact } from "../../../../../../services/Simulator/patchClientContact";
import { getFormClientConfig } from "../../../../../../services/GeneralRegistration/getFormClientConfig";
//modals
import { useAppContext } from "../../../../../../context/AppContext";
import { queryClient } from "../../../../../../utils/queryClient";
import ModalRegisterClient from "./ModalRegisterClient";

const ClientInfo = ({ clientId }) => {
  const [modal, setModal] = useState(false);
  const [select, setSelect] = useState(true);
  const [client, setClient] = useState(null);

  const [selectedClient, setSelectedClient] = useState(null);
  const [buttonNext, setButtonNext] = useState(false);

  const [doc, setDoc] = useState("");
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [editedData, setEditedData] = useState(null);

  const form = useForm();

  const { setClientId, clientData, setClientData, crmData } =
    useContextSimulator();
  const { permissions } = useAppContext();

  const handleInputRequired = async () => {
    const response = await getFormClientConfig();
    if (Array.isArray(response)) {
      localStorage.setItem("registerGeneral", response);
    }
  };

  useEffect(() => {
    handleInputRequired();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: clients, isLoading: isLoadingClients } = useQuery({
    queryKey: ["getUsers"],
    queryFn: () => getUsers({ registration_type_id: 1 }),
    refetchOnWindowFocus: true,
  });

  // console.log("clientId: ", clientId);

  useEffect(() => {
    if (clientId && clients) {
      // console.log("ClientId: ", clientId);
      handleSelect({
        value: clientId,
      });
    }
  }, [clientId, clients]);

  const handleNewClient = (newClient) => {
    queryClient.setQueryData(["getUsers"], (data) => {
      return [...data, newClient];
    });
    setModal(false);
    setButtonNext(false);
    setButtonNext(true);
    setClientData(newClient);
    setSelectedClient(newClient.id);
    setClientId(newClient.id);
    setDoc(newClient.doc);
    newClient.contacts &&
      newClient?.contacts.length > 0 &&
      setPhone(newClient.contacts[0].number);
    newClient?.email && setEmail(newClient?.email);
  };

  const handleSelect = async (e) => {
    setEmail("Carregando...");
    setPhone("Carregando...");
    setButtonNext(false);

    if (!e.value) {
      setButtonNext(false);
      setSelectedClient(null);
      return;
    }

    setClientId(e.value);
    setSelectedClient(e.value);
    setButtonNext(true);
    //    console.log("Clients: ", clients);
    const filter = clients.filter((client) => client.id === e.value);
    setClientData(filter[0]);
    var contatosArray = filter[0].contacts.split(","); // Obter o primeiro número de telefone
    setPhone(contatosArray.pop());
    setEmail(filter[0].email);
    setDoc(filter[0].id);
  };

  const handleEdit = async () => {
    if (!editedData) {
      setDoc("");
      return;
    }

    let infos = {
      client_id: doc,
    };

    if (editedData.phone) {
      infos = {
        ...infos,
        contacts: [
          {
            number: phone,
            type_number: 1,
          },
        ],
      };
    }

    if (editedData.email) {
      infos = {
        ...infos,
        email: email,
      };
    }

    const notification = toast.loading("Por favor aguarde...");

    try {
      const response = await patchClientContact(infos);
      toast.update(notification, {
        render: response.success,
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setEditedData(null);
    } catch (error) {
      toast.update(notification, {
        render: "Falha ao salvar informações!",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }
  };

  useEffect(() => {
    if (client) {
      // console.log(client);
      handleNewClient(client);
    }
  }, [client]);

  return (
    <div>
      {/* <GeneralRegistrationModal
        visible={modal}
        form={form}
        onClose={() => { setModal(false); form.reset(); }}
        setNewClient={setClient}
      /> */}

      <ModalRegisterClient
        onHide={() => {
          setModal(false);
        }}
        visible={modal}
        setNewClient={setClient}
      />

      <div className="row pt-4">
        {select && (
          <>
            <div className="col-md-7 my-auto">
              <span className="p-float-label">
                <Dropdown
                  filter
                  showClear
                  inputId="client"
                  value={selectedClient}
                  onChange={(e) => handleSelect(e)}
                  disabled={isLoadingClients || clientId ? true : false}
                  options={
                    clients &&
                    clients.map((dado) => ({
                      label: dado.name + " - " + dado.doc,
                      value: dado.id,
                    }))
                  }
                  optionLabel="label"
                  className="w-100"
                />
                <label htmlFor="client">
                  {" "}
                  {isLoadingClients ? "Carregando..." : "Selecione o comprador"}
                </label>
              </span>
              {buttonNext && (
                <div className="row mt-3">
                  <div className="col-md-6">
                    <InputText
                      placeholder="E-mail"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setEditedData((prevState) => ({
                          ...prevState,
                          email: e.target.value,
                        }));
                      }}
                      className="w-100"
                    />
                  </div>
                  <div className="col-md-6">
                    <InputMask
                      placeholder="Celular"
                      value={phone}
                      onChange={(e) => {
                        setPhone(e.target.value);
                        setEditedData((prevState) => ({
                          ...prevState,
                          phone: e.target.value,
                        }));
                      }}
                      className="w-100"
                      mask="(99) 99999-999?9"
                    />
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        {!select && (
          <div className="row justify-content-between">
            <div className="col-md-6">
              <h4>
                <span>
                  {" "}
                  <i className="fa-solid fa-user me-2 text-success"></i>Cliente:{" "}
                </span>{" "}
                {client.name}
              </h4>
            </div>
            <div className="col-md-6">
              <h4>
                <span>
                  {" "}
                  <i className="fa-solid fa-id-card me-2 text-success"></i>CPF:{" "}
                </span>{" "}
                {client.id}
              </h4>
            </div>
          </div>
        )}

        <div className="col-md-5 text-end">
          {!buttonNext ? (
            <>
              {/* {permissions && permissions.includes("9") && ( // Permissão para cadastrar novo cliente */}
                <Button
                  label="Novo Comprador"
                  icon="fa-solid fa-user-plus"
                  severity="info"
                  onClick={() => setModal(true)}
                  className="w-100"
                />
              {/* )} */}
            </>
          ) : (
            <>
              {permissions && permissions.includes("11") && ( // Permissão para editar dados do cliente
                <Button
                  label="Atualizar Dados"
                  icon="fa-solid fa-user-pen"
                  severity="warning"
                  onClick={() => handleEdit()}
                  className="w-100"
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClientInfo;
